export default __webpack_public_path__ + "static/media/PowerStorage-selected.2b492d96.png";